export enum JourneyBuilderMode {
    CREATE,
    EDIT,
    READONLY,
}
